<template>
  <!-- main wrapper (whole screen relative to the main app div) -->
  <div
    ref="modalBackgroundRef"
    data-id="bd-modal"
    class="fixed top-0 left-0 flex items-center w-screen h-screen overflow-y-auto z-modal"
  >
    <!-- black background base -->
    <transition
      name="basic-fade"
      appear
    >
      <div class="fixed w-full h-full">
        <div
          data-id="bd-modal-bg"
          class="w-full h-full bg-black opacity-50"
        />
      </div>
    </transition>
    <!-- modal on top -->
    <transition
      name="slidedown"
      appear
    >
      <div
        ref="modalRef"
        class="relative max-w-4xl m-auto bg-white rounded-md overflow-hidden"
      >
        <div
          v-if="onClose"
          class="absolute top-4 right-4 cursor-pointer modal-close"
          @click="onClose"
        >
          <!-- close modal button -->
          <CrossIcon
            class="w-5 h-5"
            alt="close-modal"
          />
        </div>
        <!-- Component to be shown -->
        <slot :on-close="onClose" />
      </div>
    </transition>
  </div>
</template>

<script>
import { ref } from 'vue';

import { CrossIcon } from '@thehotelsnetwork/icons/vue/linear';

import { onClickOutside } from '@vueuse/core';

export default {
  components: { CrossIcon },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    onClose: {
      type: Function,
      required: false,
    },
  },
  setup(props) {
    const modalRef = ref(null);
    const modalBackgroundRef = ref(null);

    onClickOutside(modalRef, ({ target }) => {
      // Do not close modal if the click was made inside the Gplaces address input
      if (!target.closest('.pac-container') && !target.closest('[data-testid="menu"]')) {
        props.onClose();
      }
    });

    return {
      modalRef,
      modalBackgroundRef,
    };
  },
};
</script>
